"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureServicesManager = void 0;
const BackgroundJobService_1 = require("../services/BackgroundJobService");
const MetricService_1 = require("../services/MetricService");
const QueueService_1 = require("../services/QueueService");
const StubErrorService_1 = require("../services/stub/StubErrorService");
/** {@inheritDoc IFeatureServicesManager} */
class FeatureServicesManager {
    constructor(opts) {
        this.stubErrorService = new StubErrorService_1.StubErrorService(opts.root);
        this.storageServices = {};
        this.cacheServices = {};
        this.queueServices = {};
        this.metricServices = {};
        this.backgroundJobs = new BackgroundJobService_1.BackgroundJobService(opts.root);
        this.options = opts;
        this.batchMetricService = new MetricService_1.BatchMetricService(opts.root);
    }
    /** {@inheritDoc IFeatureServicesManager.setEmailService} */
    setEmailService(service) {
        this.emailService = service;
    }
    /** {@inheritDoc IFeatureServicesManager.email} */
    get email() {
        if (!this.emailService) {
            throw new Error('Email Service is required, but not defined.');
        }
        return this.emailService;
    }
    /** {@inheritDoc IFeatureServicesManager.addStorageService} */
    addStorageService(service) {
        this.storageServices[service.getScheme()] = service;
    }
    /** {@inheritDoc IFeatureServicesManager.storage} */
    storage(scheme) {
        var _a;
        if (scheme) {
            if (!this.storageServices[scheme]) {
                throw new Error(`Storage scheme '${scheme}' required, but not defined.`);
            }
            else {
                return this.storageServices[scheme];
            }
        }
        else if ((_a = this.options.defaults) === null || _a === void 0 ? void 0 : _a.storage) {
            return this.storage(this.options.defaults.storage);
        }
        else if (Object.keys(this.storageServices).length) {
            return this.storageServices[Object.keys(this.storageServices)[0]];
        }
        else {
            throw new Error('A storage scheme was required, but none was defined.');
        }
    }
    allStorage() {
        return Object.values(this.storageServices);
    }
    /** {@inheritDoc IFeatureServicesManager.addCacheService} */
    addCacheService(service) {
        this.cacheServices[service.getStore()] = service;
    }
    /** {@inheritDoc IFeatureServicesManager.cache} */
    cache(store) {
        var _a;
        if (store) {
            if (!this.cacheServices[store]) {
                throw new Error(`Cache store '${store}' required, but not defined.`);
            }
            else {
                return this.cacheServices[store];
            }
        }
        else if ((_a = this.options.defaults) === null || _a === void 0 ? void 0 : _a.cache) {
            return this.cache(this.options.defaults.cache);
        }
        else if (Object.keys(this.cacheServices).length) {
            return this.cacheServices[Object.keys(this.cacheServices)[0]];
        }
        else {
            throw new Error('A cache store was required, but none was defined.');
        }
    }
    allCache() {
        return Object.values(this.cacheServices);
    }
    /** {@inheritDoc IFeatureServicesManager.addQueueService} */
    addQueueService(service) {
        this.queueServices[service.getStore()] = service;
    }
    /** {@inheritDoc IFeatureServicesManager.queue} */
    queue(store, identifier) {
        const service = this.queueServices[store];
        if (service) {
            const queue = service.getQueue(identifier);
            if (queue) {
                return new QueueService_1.BoundQueue(service, queue);
            }
            else {
                throw new Error(`Queue '${identifier}' could not be found on store '${store}'.`);
            }
        }
        else {
            throw new Error(`Queue store '${store}' does not exist.`);
        }
    }
    allQueue() {
        return Object.values(this.queueServices);
    }
    /** {@inheritDoc IFeatureServicesManager.setErrorService} */
    setErrorService(service) {
        this.errorService = service;
    }
    /** {@inheritDoc IFeatureServicesManager.error} */
    get error() {
        return this.errorService || this.stubErrorService;
    }
    addMetricService(service) {
        this.metricServices[service.getStore()] = service;
        this.batchMetricService.setServices(Object.values(this.metricServices));
    }
    metric(store) {
        if (!this.metricServices[store]) {
            throw new Error(`Metric store '${store}' does not exist.`);
        }
        return this.metricServices[store];
    }
    allMetric() {
        return this.batchMetricService;
    }
}
exports.FeatureServicesManager = FeatureServicesManager;
//# sourceMappingURL=FeatureServicesManager.js.map